module.exports = __webpack_public_path__ + "static/media/game_round_marker.940d492c.png";